import { ReactNode } from 'react';
import { isEndWithConsonant, LanguageEnum } from './';

const enScript = {
  Take5Minutes: '*Take 5 minutes to apply for a free eligibility check!*',
  ThisIsAnEstimated:
    'This is an estimated price. Final price will be confirmed after consultation with IP specialists.',
  OurIPExperts:
    'Our IP experts will review your application and create the most optimized strategy for your IP registration.',
  YouCanMakeChanges:
    'You can make changes after the consultation, so please fill out this information to the best of your ability.',
  SendRequest: 'Send request',

  // re:catch
  HiThere: 'Hi there',
  NotSureHowTo: (
    <>
      Not sure how to proceed?
      <br />
      Get in touch with our IP experts for help
      <br />
      with any doubts about your application.
    </>
  ),
  BookAFree: 'Book a FREE consultation',

  // Type of IP
  SelectOneCategoryToProtect: 'Select one category to protect',
  TypeOfIP: 'Type of IP',
  Trademark: 'Trademark',
  DesignRight: 'Design right',
  PleaseProvideYourWebsite: 'Please provide your website URL or any files that show the designs you wish to register',
  EgAdidas: 'e.g. adidas',

  // Countries
  Countries: 'Countries',
  GoodsN: (n: number) => (
    <>
      <span>{n}</span> good{n === 1 ? '' : 's'}/service{n === 1 ? '' : 's'}
    </>
  ),
  CompleteSelection: 'Complete selection',
  ClearAll: 'Clear all',
  NotSureWhichCountries:
    'Not sure which countries to file? Check out our packages. If you have decided where to file, select countries one by one.',
  SelectAPackage: 'Select a package',
  SelectOneByOn: 'Select one by one',
  Additional5Discount: 'Additional 5% discount',
  AddOn: 'Add-on',
  AddProtectionPlan: 'Add Protection Plan',
  WorriedAbout:
    'Worried about your trademark facing rejection? Add our Protection Plan and get a full 100% refund of service fees in case of rejection.',
  NeedMoreInfo: 'Need more information?',
  MarqFolioProtection:
    "MARQ Folio's Protection Plan offers you (1) unlimited support for preliminary rejections and (2) a 100% service fee refund if your trademarks are rejected. You don't need to select the Plan for all countries and Classes. Our trademark experts will be delighted to discuss the most optimized strategy with you during the meeting.",
  BrowseMoreCountries: 'Browse more countries',
  IfThereIsAnyUncertainty:
    'If there is any uncertainty, let our trademark specialists help you select the most optimal countries.',
  GetCountrySuggestions: 'Get country suggestions',
  SelectTheCountries: 'Select the countries in which you wish to file ',
  LowestPriceGuarantee: 'Lowest price guarantee',
  HighestRegistrationRage: 'Highest registration rate',
  FastestRegistration: 'Fastest registration',
  EgCountry: 'Country 1, Country 2, Country 3',

  // Goods and services
  GoodsAndServices: 'Goods and services',
  WhatGoods: 'What goods or services do you sell?',
  EgBread: 'e.g. Bread, cosmetics, clothing, Class 1, 43',
  UnsureOfClasses: 'Unsure of Classes?',
  HelpUsCarry:
    'Help us carry a more comprehensive similarity screening before filing applications. Class information only needs to be finalized before the application, so no need to overly stress about perfection at this stage.',
  PleaseProvideUsYour:
    'Please provide us your website URL or any files that can offer a clearer understanding of your products or services (optional)',
  Or: 'OR',
  SignInToSeePrice: (event: () => void): ReactNode => (
    <>
      <button
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          event();
        }}
      >
        Sign in
      </button>
      <span>to see price</span>
    </>
  ),
  Select4CountryAndMultiDiscount: (
    <>
      Select 4 or more countries and <span>SAVE 10%</span>
    </>
  ),
  SelectNCountryAndMultiDiscount: (n: number) => (
    <>
      Select {n} more countr{n === 1 ? 'y' : 'ies'} and <span>SAVE 10%</span>
    </>
  ),
  TrademarkSentry: 'Trademark Sentry',
  StartupPioneer: 'Startup Pioneer',
  FashionistaFortress: 'Fashionista Fortress',
  NPackageSelected: (n: number) => (
    <>
      <span>{n}</span> package{n === 1 ? '' : 's'}
    </>
  ),
  NCountrySelected: (n: number) => (
    <>
      <span>{n}</span> countr{n === 1 ? 'y' : 'ies'}
    </>
  ),
  AddPackageAndDiscount: (countries: ReactNode) => (
    <>
      Add {countries} and <span>SAVE additional 5%</span>
    </>
  ),
  AddAndSave5: 'Add and SAVE 5%',
  PriceTooltip: (firstPrice: number, addPrice: number) =>
    `1 Class costs $${firstPrice.toLocaleString()}, each additional Class costs $${addPrice.toLocaleString()}`,
  YouSelectedBefore: "You've selected",
  YouSelectedAfter: '',

  // Applicant details
  ApplicantDetails: 'Applicant details',
  WhoIsTheIntendedDr: 'Who is the intended owner of the design right?',
  EmailAddress: 'Email address',
  EnterInput: (value: string) => `Enter ${value.toLowerCase()}`,
  SelectOption: (value: string) => `Select ${value.toLowerCase()}`,
  NationalityDr: 'Nationality of design right owner',
  WhoIsTheIntendedTm: 'Who is the intended owner of the trademark?',
  TrademarkOwnerName: 'Legal name of individual owner',
  YouHaveAnAccount: 'You have an account! Please sign in.',
  ThisEmailAccountDoesNot: 'This email account does not exist. Please try again or sign up.',

  // Summary
  ToSeeEstimatedPrice: 'to see estimated price',
  ThisIsAnEstimatedPrice:
    'This is an estimated price. Final price will be confirmed after consultation with IP specialists.',
  PriceEstimationIsCurrently:
    "Price estimation is currently unavailable for this country. We'll response to your request shortly.",
  PackageDiscount: (n: number) => `${n}% package discount`,
  CountriesWillBeSuggested: 'Countries will be suggested',

  // TY
  WeWillSend: 'We will send you a free eligibility report in 1 business day',
  DoYouWantToSchedule: 'Do you want to schedule a free 15 minute consultation with our IP specialist?',
  WantToPayNow: 'Want to pay now to speed up your application?',
  YourTrademarkSubmissionIsReviewed:
    'Our partner law firm will review your application and get back to you with in-depth analysis and recommendations',
  GoToPayment: 'Go to payment',
};

export type LocalizedFileStringsType = typeof enScript;

const koScript: LocalizedFileStringsType = {
  Take5Minutes: '*무료 상표 조사를 신청해보세요 (5분 소요)*',
  ThisIsAnEstimated: '위 견적은 예상 금액으로, 출원 상담 후 최종 금액이 확정됩니다',
  OurIPExperts: '마크폴리오의 IP 전문가들이 신청서 내용을 바탕으로 최적화된 IP 출원 전략을 제안해드릴 예정입니다.',
  YouCanMakeChanges: '상담 후 출원 전에 상세 내용은 변경할 수 있으니, 부담없이 작성해주셔도 됩니다.',
  SendRequest: '제출',

  // re:catch
  HiThere: '반가워요!',
  NotSureHowTo: (
    <>
      진행에 어려움이 있으신가요?
      <br />
      저희 IP 전문가에게
      <br />
      상표 출원 방향을 상담 받아보세요.
    </>
  ),
  BookAFree: '무료 상담 예약',

  // Type of IP
  SelectOneCategoryToProtect: '출원할 IP 유형을 선택해주세요',
  TypeOfIP: 'IP 유형',
  Trademark: '상표권',
  DesignRight: '디자인권',
  PleaseProvideYourWebsite: '출원할 디자인에 대한 설명 자료 혹은 홈페이지 주소를 첨부해주세요',
  EgAdidas: '예: Adidas',

  // Countries
  Countries: '국가',
  GoodsN: (n: number) => (
    <>
      <span>{n}</span>개 지정상품/서비스
    </>
  ),
  CompleteSelection: '선택 완료',
  ClearAll: '전체 초기화',
  NotSureWhichCountries:
    '출원할 국가를 정하지 못하셨다면 패키지를 확인해보세요. 출원을 희망하는 국가가 있다면 개별 국가로 선택해주세요.',
  SelectAPackage: '패키지',
  SelectOneByOn: '개별 국가',
  Additional5Discount: '추가 5% 할인',
  AddOn: '추가 서비스',
  AddProtectionPlan: '환불 보장 플랜 추가',
  WorriedAbout:
    '상표가 거절될까봐 걱정이신가요? 환불 보장 플랜을 추가하시면 거절 시 서비스 비용을 100% 환불 받으실 수 있습니다.',
  NeedMoreInfo: '더 알아보기',
  MarqFolioProtection:
    '마크폴리오의 환불 보장 플랜은 (1) 중간 사건에 대한 무제한 지원 및 (2) 거절 시 서비스비 100% 환불을 보장합니다. 모든 국가와 상품분류에 대해 환불 보장 플랜을 추가하실 필요는 없습니다. 저희 상표 전문가들이 상담 이후 거절 가능성이 높은 국가와 상품 분류에 대해 안내드릴 예정입니다.',
  BrowseMoreCountries: '기타 국가 추가',
  IfThereIsAnyUncertainty:
    '어떤 국가에 출원이 필요할지 잘 모르시겠나요? 저희 상표 전문가들이 업종과 스테이지에 맞추어 국가를 추천해드립니다.',
  GetCountrySuggestions: '국가 추천 받기',
  SelectTheCountries: '출원할 국가를 선택해주세요',
  LowestPriceGuarantee: '최저가 보장',
  HighestRegistrationRage: '높은 등록성공률',
  FastestRegistration: '가장 빠른 등록',
  EgCountry: '국가 1, 국가 2, 국가 3',

  // Goods and services
  GoodsAndServices: '상품 및 서비스',
  WhatGoods: '어떤 상품 혹은 서비스를 판매하고 계신가요?',
  EgBread: '예: 빵, 화장품, 제1류, 제43류',
  UnsureOfClasses: '상품분류 선택이 어려우신가요?',
  HelpUsCarry:
    '출원 전 동일/유사 상표가 존재하진 않는지 미리 스크리닝하기 위해 상품분류 정보가 필요합니다. 상품분류는 상담 이후 출원 시점에 확정되면 되므로, 현 단계에서는 부담 없이 선택해주시면 됩니다.',
  PleaseProvideUsYour: '상품 혹은 서비스에 대한 설명 자료 혹은 홈페이지 주소를 첨부해주세요 (선택)',
  Or: '또는',
  SignInToSeePrice: (event: () => void) => (
    <>
      <button
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          event();
        }}
      >
        로그인
      </button>
      <span>하고 가격 보기</span>
    </>
  ),
  Select4CountryAndMultiDiscount: (
    <>
      4개 이상 국가 선택하고 <span>10% 할인</span> 받기
    </>
  ),
  SelectNCountryAndMultiDiscount: (n: number) => (
    <>
      {n}개 국가 추가 선택하고 <span>10% 멀티 국가 할인</span> 받기
    </>
  ),
  TrademarkSentry: '선점 방지 패키지',
  StartupPioneer: '스타트업 패키지',
  FashionistaFortress: '패션/뷰티 패키지',
  NPackageSelected: (n: number) => (
    <>
      <span>{n}</span>개 패키지
    </>
  ),
  NCountrySelected: (n: number) => (
    <>
      <span>{n}</span>개 국가
    </>
  ),
  AddPackageAndDiscount: (countries: ReactNode) => (
    <>
      {countries} 추가하고 <span>추가 5% 할인</span> 받으세요
    </>
  ),
  AddAndSave5: '국가 추가',
  PriceTooltip: (firstPrice: number, addPrice: number) =>
    `1개 류 가격은 $${firstPrice.toLocaleString()}이며 상품 류가 추가될 때마다 $${addPrice.toLocaleString()}가 추가됩니다`,
  YouSelectedBefore: '',
  YouSelectedAfter: '선택됨',

  // Applicant details
  ApplicantDetails: '신청자 정보',
  WhoIsTheIntendedDr: '디자인 권리자는 누구인가요?',
  EmailAddress: '이메일 주소',
  EnterInput: (value) => `${value}${isEndWithConsonant(value) ? '을' : '를'} 입력해주세요`,
  SelectOption: (value) => `${value}${isEndWithConsonant(value) ? '을' : '를'} 선택해주세요`,
  NationalityDr: '국적',
  WhoIsTheIntendedTm: '상표권자는 누구인가요?',
  TrademarkOwnerName: '권리자 이름',
  YouHaveAnAccount: '이미 가입된 이메일 입니다. 로그인 해주세요.',
  ThisEmailAccountDoesNot: '존재하지 않는 이메일 계정입니다. 다시 시도해 보거나 가입해주세요.',

  // Summary
  ToSeeEstimatedPrice: '후 견적 확인',
  ThisIsAnEstimatedPrice: '위 견적은 예상 금액으로, 출원 상담 후 최종 금액이 확정됩니다',
  PriceEstimationIsCurrently: '해당 국가는 현재 견적 제공이 어렵습니다. 빠르게 가능 여부 확인해 답변 드릴게요.',
  PackageDiscount: (n) => `패키지 ${n}% 할인`,
  CountriesWillBeSuggested: '국가 추천 예정',

  // TY
  WeWillSend: '1 영업일 내로 무료 조사보고서를 전달드리겠습니다',
  DoYouWantToSchedule: '출원 전략에 대한 15분 무료 상담을 받아보시겠어요?',
  WantToPayNow: '바로 결제 후 빠른 출원 진행을 원하시나요?',
  YourTrademarkSubmissionIsReviewed: '파트너 로펌에서 신청서를 리뷰한 후 출원 전략을 전달드릴 예정입니다',
  GoToPayment: '결제',
};

const LocalizedFileStrings: Record<LanguageEnum, LocalizedFileStringsType> = {
  [LanguageEnum.English]: enScript,
  [LanguageEnum.Korean]: koScript,
};

export default LocalizedFileStrings;
